import { Link } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';

export default function DealerCTA() {
  const { theme } = useTheme();
  const light = theme === 'light';

  const sectionBg = light ? 'bg-white' : 'bg-[#0D1B2A]';
  const cardBg = light ? 'bg-gray-100 border border-gray-200' : 'bg-[#1C2B3A]';
  const headingColor = light ? 'text-gray-900' : 'text-white';
  const bodyColor = light ? 'text-gray-500' : 'text-white/60';
  const outlineBtn = light
    ? 'border border-gray-300 text-gray-700 hover:bg-gray-100'
    : 'border border-white/30 text-white hover:bg-white/10';

  return (
    <section className={`${sectionBg} w-full py-20 transition-colors duration-300`}>
      <div className="w-full px-6 md:px-10">
        <div className={`relative ${cardBg} rounded-lg overflow-hidden`}>
          <div className="absolute inset-0 opacity-5">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20geometric%20carbon%20fiber%20texture%20dark%20background%20pattern%20industrial%20metal%20mesh%20grid%20lines%20dark%20navy%20charcoal%20minimal%20seamless%20pattern%20high%20resolution%20texture&width=1200&height=400&seq=dealer-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 px-10 py-14">
            <div className="text-center lg:text-left">
              <div className="flex items-center gap-3 justify-center lg:justify-start mb-4">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-full"
                  style={{ backgroundColor: 'color-mix(in srgb, var(--accent) 20%, transparent)', border: '1px solid color-mix(in srgb, var(--accent) 40%, transparent)' }}
                >
                  <i className="ri-store-2-line text-lg" style={{ color: 'var(--accent)' }}></i>
                </div>
                <span className="text-xs font-bold tracking-widest uppercase" style={{ color: 'var(--accent)' }}>Dealer Portal</span>
              </div>
              <h2 className={`text-3xl md:text-4xl font-black ${headingColor} mb-3`}>
                Are You a Stingray Dealer?
              </h2>
              <p className={`${bodyColor} text-base max-w-xl`}>
                Access our exclusive dealer portal to browse inventory, create orders, and manage your account. Fast, simple, and built for your business.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 shrink-0">
              <Link
                to="/dealer"
                className="text-white font-bold px-8 py-4 rounded-md transition-colors text-center cursor-pointer whitespace-nowrap text-sm tracking-wide uppercase"
                style={{ backgroundColor: 'var(--accent)' }}
              >
                Sign In to Portal
              </Link>
              <Link
                to="/dealer/apply"
                className={`${outlineBtn} font-bold px-8 py-4 rounded-md transition-colors text-center cursor-pointer whitespace-nowrap text-sm tracking-wide uppercase`}
              >
                Become a Dealer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
